import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const SaleEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    //const [formData, setFormData] = useState({});
    const [formData, setFormData] = useState({
        ID: '',
        CompanyID: '',
        CustomerID: '',
        BillStatusID: '',
        InvoiceDate: '',
        InvoiceNo: '',
        InvoiceNumber: '',
        Amount: '',
        Discount: '',
        DiscountPer: '',
        NetAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        RoundOff: '',
        TotalAmount: '',
        IsPaymentMethod: '',
        FinYear: '',
        CustomerName: '',
        UpdatedBy: userId,
        CustomerContact: '',
    });

    const [itemdata, setData] = useState([]);


    useEffect(() => {
        fetchData('SaleItemApi', `/SaleDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setData(response.response_data.SaleDetails);
                    console.log(response);

                }

                setFormData((prevData) => ({
                    ...prevData,
                    UpdatedBy: userId,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;

        if (name === 'DiscountPer') {
            const discountPercentage = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                DiscountPer: discountPercentage.toFixed(2),
                UpdatedBy: userId,
            }));


            // Calculate discount and other values for each item in itemdata
            const updatedItemData = itemdata.map((item) => {
                const amount = parseFloat(item.Amount) || 0;
                const discountAmount = (amount * discountPercentage) / 100;
                const netAmount = (amount - discountAmount).toFixed(2);
                const cgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const sgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                return {
                    ...item,
                    DiscountPer: discountPercentage.toFixed(2),
                    DiscountAmount: discountAmount.toFixed(2),
                    NetAmount: netAmount,
                    CGSTAmount: cgstAmount,
                    SGSTAmount: sgstAmount,
                    TotalAmount: totalAmount,
                };
            });

            setData(updatedItemData);


            // Update the totals based on the updatedItemData
            const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            // const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const igstAmount = 0;
            const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);

        } else if (name === 'DiscountAmount') {

            const discountAmount = parseFloat(value) || 0;
            const amount = parseFloat(formData.Amount) || 0;
            const discountPercentage = ((discountAmount / amount) * 100).toFixed(2);

            setFormData((prevData) => ({
                ...prevData,
                DiscountPer: discountPercentage,
                DiscountAmount: discountAmount,
                UpdatedBy: userId,
            }));

            // Calculate discount and other values for each item in itemdata
            const updatedItemData = itemdata.map((item) => {
                const amount = parseFloat(item.Amount) || 0;
                const discountAmount = (amount * discountPercentage) / 100;
                const netAmount = (amount - discountAmount).toFixed(2);
                const cgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const sgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                return {
                    ...item,
                    DiscountPer: discountPercentage,
                    DiscountAmount: discountAmount.toFixed(2),
                    NetAmount: netAmount,
                    CGSTAmount: cgstAmount,
                    SGSTAmount: sgstAmount,
                    TotalAmount: totalAmount,
                };
            });

            setData(updatedItemData);


            // Update the totals based on the updatedItemData
            const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            // const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const igstAmount = 0;
            const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            // totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discountAmount);
            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);

        }
        else {
            // Update other fields as usual
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? !prevData[name] : value,
            }));
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: itemdata
        };

        // Validate form data here if needed

        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/SIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...itemdata];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setData(updatedRecords); // Update the state to reflect the removed record 

            let invAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            let netAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            let cgstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            let sgstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            // let igstAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            let igstAmount = 0;
            let discAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);
        }

    };

    const totalCalculation = (invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount) => {
        let amount = parseFloat(invAmount);
        let netamount = parseFloat(netAmount);
        let netAmt = netAmount + parseFloat(cgstAmount) + parseFloat(sgstAmount) + parseFloat(igstAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmount = (netAmt + roundOffValue).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            Amount: amount.toFixed(2),
            NetAmount: netamount.toFixed(2),
            TotalAmount: totalAmount,
            DiscountAmount: discAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            CGSTAmount: cgstAmount.toFixed(2),
            SGSTAmount: sgstAmount.toFixed(2),
            IGSTAmount: igstAmount.toFixed(2),
            UpdatedBy: userId,
        }));
    };

    const handleCalculation = (e, index) => {
        const { name, value } = e.target;
        const discountPercentage = parseFloat(formData.DiscountPer) || 0;

        const updatedItemData = itemdata.map((item, i) => {
            if (i === index) {
                if (name === 'Quantity') {
                    const quantity = parseFloat(value) || 0;
                    const rate = parseFloat(item.Rate) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    const cgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Quantity: quantity,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                    };
                } else if (name === 'Rate') {
                    const rate = parseFloat(value) || 0;
                    const quantity = parseFloat(item.Quantity) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    const cgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Rate: rate,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                    };
                }
            }
            return item;
        });

        setData(updatedItemData);

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const cgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
        const sgstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
        // const igstAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
        const igstAmount = 0;
        const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

        totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{maxWidth:'95%'}}>

                <style>
                    {`
                        .radio-group label {
                            display: inline-block;
                            margin-right: 10px;
                        }
                        
                        .radio-group input {
                            transform: scale(1.5); 
                            margin-right: 5px;
                            margin-top:10px;
                        }
        
                     `}
                </style>
                <form onSubmit={handleSubmit}>
                    <div className="w-full mb-2 flex">
                        {/* <h4 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale - Edit</h4> */}
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SALE EDIT</h6>

                        <Tooltip title="Exit">
                            <Link to="/SIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Back To List  <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="Update">

                            <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>

                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}
                    <div className="flex">
                        <div className="w-1/2 pr-4">
                            <div className="bg-blue-450 rounded-lg shadow-lg p-6">
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Customer : {formData.CustomerName}
                                        </label>
                                    </div>
                                    <div className="w-1/7 mr-3">

                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Invoice No : {formData ? formData.InvoiceNo : ''}

                                        </label>

                                    </div>
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Invoice Date : {formatDateForInput(formData.InvoiceDate)}

                                        </label>

                                    </div>

                                </div>
                                <div className="w-full mb-4 flex">

                                    <div className="w-1/2 radio-group">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="paymentType">
                                            Payment Type
                                        </label>
                                        <div className="flex items-center text-black">
                                            <label className="mr-2 text-black">
                                                <input
                                                    type="radio"
                                                    name="IsPaymentMethod"
                                                    value="1"
                                                    checked={formData.IsPaymentMethod.toString() === '1'}
                                                    onChange={handleChange}
                                                />
                                                Cash
                                            </label>
                                            <label className="mr-2 text-black">
                                                <input
                                                    type="radio"
                                                    name="IsPaymentMethod"
                                                    value="2"
                                                    checked={formData.IsPaymentMethod.toString() === '2'}
                                                    onChange={handleChange}
                                                />
                                                Credit
                                            </label>
                                            <label className='text-black'>
                                                <input
                                                    type="radio"
                                                    name="IsPaymentMethod"
                                                    value="3"
                                                    checked={formData.IsPaymentMethod.toString() === '3'}
                                                    onChange={handleChange}
                                                />
                                                UPI
                                            </label>
                                        </div>

                                    </div>

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Amount
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.Amount).toFixed(2)}
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Amount"
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Discount %
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.DiscountPer).toFixed(2)}
                                            onChange={handleChange}
                                            name='DiscountPer'
                                            type="number"
                                            placeholder="Enter Discount %"
                                        />
                                    </div>

                                </div>


                                <div className="w-full mb-1 flex">
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Discount Amount

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.Discount).toFixed(2)}
                                            onChange={handleChange}
                                            name='discount'
                                            type="number"
                                            placeholder="Enter Discount Amount"
                                            readOnly
                                        />
                                    </div>
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Net Amount

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.NetAmount).toFixed(2)}
                                            name='NetAmount'
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Net Amount"
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            CGST

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.CGSTAmount).toFixed(2)}
                                            onChange={handleChange}
                                            name='CGSTAmount'
                                            type="number"
                                            placeholder="Enter CSGT"
                                            readOnly
                                        />
                                    </div>
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            SGST

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.SGSTAmount).toFixed(2)}
                                            onChange={handleChange}
                                            name='SGSTAmount'
                                            type="number"
                                            placeholder="Enter SGST"
                                            readOnly
                                        />
                                    </div>

                                </div>
                                <div className="w-full mb-1 flex">

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            IGST

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.IGSTAmount).toFixed(2)}
                                            onChange={handleChange}
                                            name='IGSTAmount'
                                            type="number"
                                            placeholder="Enter IGST"
                                            readOnly
                                        />
                                    </div>
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Round Off

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.Roundoff).toFixed(2)}
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Round Off"
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="rate">
                                            Total Amount

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.TotalAmount).toFixed(2)}
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Total Amount"
                                            readOnly
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="w-1/2 pl-4">
                            <div className="bg-teal-450 rounded-lg shadow-lg p-6">
                                <div className="w-full mb-4 flex">
                                    <div className="w-full mb-4 flex-horizontal">
                                        <TableContainer component={Paper}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th style={{ padding: '8px' }}>Item Name</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Quantity</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Rate</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Disc %</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Total</th>
                                                        <th style={{ padding: '8px' }}>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {Array.isArray(itemdata) && itemdata.map((invdetail, index) => (
                                                        invdetail ? (
                                                            <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                                <td style={{ padding: '8px', fontSize: '14px' }}>{invdetail.Spare}</td>

                                                                <td style={{ padding: '1px', fontSize: '14px', width: '10%', textAlign: 'center', backgroundColor: invdetail.quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                                    <input
                                                                        type="number"
                                                                        value={invdetail.Quantity}
                                                                        onChange={(e) => handleCalculation(e, index)}
                                                                        style={{ maxWidth: '120px', textAlign: 'right' }}
                                                                        name="Quantity"

                                                                    />
                                                                </td>
                                                                <td style={{ padding: '8px', fontSize: '14px', textAlign: 'center' }}>{invdetail.Rate}</td>
                                                                <td style={{ padding: '8px', fontSize: '14px', textAlign: 'center' }}>{invdetail.DiscountPer}</td>
                                                                <td style={{ padding: '8px', fontSize: '14px', textAlign: 'center' }}>{invdetail.TotalAmount}</td>
                                                                <td style={{ padding: '8px', marginTop: '-15px' }}>
                                                                    {hasDeleteTransactionPermission && (
                                                                        <Tooltip title="Delete Invoiced Item">
                                                                            <IconButton style={{ padding: '8px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                                                <DeleteIcon style={{ color: '#FF5733' }} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ) : null
                                                    ))}
                                                </tbody>

                                            </table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </form>
            </div >
        </Fragment >

    );
};

export default SaleEdit;
